import { render, staticRenderFns } from "./shopOverview.vue?vue&type=template&id=e5a749dc&scoped=true&"
import script from "./shopOverview.vue?vue&type=script&lang=js&"
export * from "./shopOverview.vue?vue&type=script&lang=js&"
import style0 from "./shopOverview.vue?vue&type=style&index=0&id=e5a749dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a749dc",
  null
  
)

export default component.exports